import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
} from "@/shared/components/ui/breadcrumb";
import { Separator } from "@/shared/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/shared/components/ui/sidebar";

import { withTranslation } from "react-i18next";
import { TFunction } from "i18next";
import DashboardLayoutViewModel from "./dashboard-layout-view-model";
import { SimpleDashboardSidebar } from "./simple-dashboard-sidebar/simple-dashboard-sidebar";
import { Skeleton } from "@/shared/components/ui/skeleton";
import UploadCreditCardPopover from "@/features/dashboard/pages/setting/pages/plans-and-billings/components/upload-credit/upload-credit-card-popover";
import UserDropdown from "@/shared/components/user-dropdown/user-dropdown";

declare global {
  var newrelic: any;
}

const DashboardLayout = ({
  children,
  t,
  title = "dashboard",
  header = true,
  skeleton = false,
}: {
  children: React.ReactNode;
  t: TFunction;
  title?: string;
  header?: boolean;
  skeleton?: boolean;
}) => {
  const { } = DashboardLayoutViewModel();

  return (
    <SidebarProvider className="bg-sidebar">
      <SimpleDashboardSidebar skeleton={skeleton} />
      <SidebarInset className="p-[6px] bg-sidebar !border-none overflow-hidden left-[240px] md:max-w-[calc(100%-240px)]">
        <div className="border border-[#E4E4E7] rounded-[12px] bg-white h-full">
          {header && (
            <header className="flex shrink-0 items-center justify-between gap-2 border-b border-[#E4E4E7] mb-[24px] mx-[16px] h-[50px]">
              <div className="flex items-center gap-2 ">
                {!skeleton && <SidebarTrigger className="-ml-1" />}
                {skeleton && (
                  <Skeleton className="h-5 w-5 bg-zinc-100 rounded-[6px]" />
                )}
                <Separator orientation="vertical" className="mr-2 h-4" />
                {!skeleton && (
                  <Breadcrumb>
                    <BreadcrumbList>
                      <BreadcrumbItem className="breadcrumb-item hidden md:block text-sm font-600 text-zinc-950 leading-5 ">
                        <BreadcrumbLink href="#">{t(title)}</BreadcrumbLink>
                      </BreadcrumbItem>
                      {/* <BreadcrumbSeparator className="breadcrumb-separator hidden md:block" /> */}
                      {/* <BreadcrumbItem>
                  <BreadcrumbPage></BreadcrumbPage>
                </BreadcrumbItem> */}
                    </BreadcrumbList>
                  </Breadcrumb>
                )}
                {skeleton && (
                  <Skeleton className="h-5 w-[100px] bg-zinc-100 rounded-[6px]" />
                )}
              </div>
              {!skeleton && (
                <div className="flex items-center gap-1">
                  <UploadCreditCardPopover />
                  <UserDropdown />
                </div>
              )}
            </header>
          )}
          <div className="flex flex-1 flex-col gap-x-4 gap-y-6 p-4 pt-0 h-full  has-[.no-padding-child]:pb-0">
            {children}
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default withTranslation()(DashboardLayout);
